import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import getSetCookie from '../../../../cookie';
import { isExchangeFlowSet } from '../../../../actionCreators/myAccount';
import { showLoader, hideLoader } from '../../../../actionCreators/returnExchange';
import * as commonAction from '../../../../actionCreators/common';
import LinkProvider from '../../../../CommonComponents/LinkProvider/LinkProvider';
import {
  saveUserAddress,
  getReturnReasons,
  getOrderItemsReturnElgibilty,
  createReturn,
  cancelReturnItem,
  setCurrentReturnItem,
  setNewExchangeFLow,
  setExchangeOrderAndItem,
} from '../../../../actionCreators/returnExchange';
import SelectReason from './SelectReason';
import { getOrder } from '../../../../actionCreators/order';
import ReturnProductCard from './ReturnProductCard';
import ReturnChooseMode from './ReturnChooseMode';
import ConfirmationRequest from './ConfirmationRequest';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import AddPower from './AddPower';
import CommonLoader from '../../../components/Common/Loader';
import ReturnTypeMethod from './ReturnTypeMethod';
import ShippingAddressExchange from './ShippingAddressExchange';

import './CommonStyles.scss';

let returnId = null;
function ReturnReasonNew(props) {
  const {
    isExchangeFlowSet,
    match,
    location,
    getOrder,
    commonAction,
    userAddress,
    orderDetails,
    saveUserAddress,
    currentReturnItem,
    setCurrentReturnItem,
    history,
    exchangeFlowSet,
    cartData,
    dataLocale,
    returnConfig,
    returnEligibiliyDetails,
    getOrderItemsReturnElgibilty,
    setExchangeOrderAndItem,
    exchangeNewFlow,
    setNewExchangeFLow,
    powerSubmitted,
    isLoading,
    showLoader,
    hideLoader,
  } = props;
  // Is VSM order
  const isExchangeOnlyCase = sessionStorageHelper.getItem('isExchangeOnlyCase');
  const data = sessionStorageHelper.getItem('returnStep') || {};
  const refundMethodRequest = sessionStorageHelper.getItem('refundMethod');
  const { EXCHANGE_RETURN, SELECT_REASON } = dataLocale;
  const [open, setOpen] = useState(false);
  const [secondStep, setSecondStep] = useState(data.secondStep || false);
  const [thirdStep, setThirdStep] = useState(data.thirdStep || isExchangeOnlyCase || false);
  const [fourthStep, setFourthStep] = useState(data?.fourthStep || false);
  const [finalStep, setFinalStep] = useState(data?.finalStep || '');
  const [showFinalSubmitBtn, setShowFinalSubmitBtn] = useState(true);
  const [returnIdItem, setReturnId] = useState(null);
  const [fifthStep, setFifthStep] = useState(data?.fifthStep || false);
  const selectedPowerStorage = sessionStorageHelper.getItem('selectedPower');
  const [selectedPower, setSelectedPowerState] = useState(selectedPowerStorage);
  const powerMethodStorage = sessionStorageHelper.getItem('powerMethod');
  const [method, setMethodState] = useState(powerMethodStorage || '');
  const returnOrderId = location?.state?.orderId || match?.params?.id;
  const returnItemId = location?.state?.itemId || match?.params?.itemId;
  const [isExpandable, setIsExpandable] = useState(
    isExchangeOnlyCase ? dataLocale.EXCHANGE_OR_REFUND : data.isExpandable || SELECT_REASON
  );
  const returnPrimaryReason = location?.state?.primaryReason;
  const currentItem =
    orderDetails &&
    orderDetails?.result?.orders?.[0]?.items?.find(order => order.id + '' === returnItemId + '');
  // Custom for add power in return exchange
  if (currentItem) currentItem.powerRequired = 'POWER_REQUIRED';
  const items =
    orderDetails && orderDetails?.result?.orders && orderDetails?.result?.orders[0]?.items;
  const shippingAddress =
    orderDetails &&
    orderDetails.result &&
    orderDetails.result.orders &&
    orderDetails.result.orders[0] &&
    orderDetails.result.orders[0].shippingAddress;

  const setMethod = method => {
    sessionStorageHelper.setItem('powerMethod', method);
  };

  const setSelectedPower = data => {
    // Show loader for 1 second
    showLoader();
    setTimeout(() => {
      setSelectedPowerState(data);
      sessionStorageHelper.setItem('selectedPower', data);
      hideLoader();
    }, 1000);
  };
  const SecStep = value => {
    setSecondStep(value);
    saveUserAddress(shippingAddress);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    returnStep = {
      ...returnStep,
      secondStep: value,
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
  };
  const showREtype = () => {
    setThirdStep(true);
  };

  useEffect(() => {
    if (currentReturnItem) {
      const productId = currentReturnItem?.item?.productId;
      commonAction.getRedisRouter({ productId, location });
    }
    if (currentReturnItem && currentReturnItem.item && !returnIdItem) {
      if (currentItem && currentItem.returnId) {
        const { itemTracking, returnId: itemReturnId } = currentReturnItem.item;
        returnId =
          itemReturnId && itemTracking?.status !== 'RETURN_CANCELLED' ? itemReturnId : null;
        if (returnId) {
          setReturnId(returnId);
          setIsExpandable(dataLocale.EXCHANGE_OR_REFUND);
          setThirdStep(true);
        }
      }
    }
  }, [currentReturnItem]);

  useEffect(() => {
    if (!exchangeFlowSet) {
      isExchangeFlowSet(true);
    }
  }, [exchangeFlowSet]);

  useEffect(() => {
    isExchangeFlowSet(true);
    let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
    productToReturn = {
      ...productToReturn,
      returnProductId: returnItemId,
    };
    sessionStorageHelper.setItem('returnProduct', productToReturn);
    if (data.fourthStep || data.isExpandable === 'Shipping Address') {
      sessionStorageHelper.removeItem('exchangeNP');
    }
    if (!exchangeNewFlow) setNewExchangeFLow(true);
    let exchangeFlow = sessionStorageHelper.getItem('exchangeFlow');
    exchangeFlow = true;
    sessionStorageHelper.setItem('exchangeFlow', exchangeFlow);
    setExchangeOrderAndItem(returnOrderId, returnItemId);
    if (returnOrderId && returnConfig?.enableNewFlow) getOrderItemsReturnElgibilty(returnOrderId);
    if (isExchangeOnlyCase) setIsExpandable(dataLocale.EXCHANGE_OR_REFUND);
    saveUserAddress(shippingAddress);
    let id = sessionStorageHelper.getItem('returnItemId') || {};
    id = returnItemId;
    sessionStorageHelper.setItem('returnItemId', id);
    getSetCookie.setCookie('exchangeOrderId', returnOrderId);
    getSetCookie.setCookie('exchangeItemId', returnItemId);
    getOrder({ orderId: returnOrderId, dontInitSession: true, isMyAcct: true });
    return () => {
      isExchangeFlowSet(false);
    };
  }, [returnConfig]);

  useEffect(() => {
    if (powerSubmitted) {
      getOrder({ orderId: returnOrderId, dontInitSession: true, isMyAcct: true, isExchange: true });
      setOpen(false);
    }
  }, [powerSubmitted]);

  useEffect(() => {
    if (cartData && cartData.itemsCount > 0) {
      setOpen(false);
      const returnStep = sessionStorageHelper.getItem('returnStep') || {};
      setFourthStep(returnStep.fourthStep);
      setFifthStep(returnStep.fifthStep);
      if (returnStep) setFinalStep(returnStep.finalStep);
      setIsExpandable(returnStep.isExpandable);
    }
    if (cartData?.items.length === 0) setShowFinalSubmitBtn(true);
  }, [cartData]);

  useEffect(() => {
    if (shippingAddress) {
      saveUserAddress(shippingAddress);
    }
  }, [secondStep]);

  useEffect(() => {
    if (returnItemId && items && items.length) {
      const returnProductItems = items?.filter(item => returnItemId == item.id); // eslint-disable-line
      const currentItemReturnEligibiliyDetails =
        returnEligibiliyDetails?.items?.find(item => item.id == returnItemId) || {}; // eslint-disable-line
      setCurrentReturnItem({
        item: { ...returnProductItems[0], ...currentItemReturnEligibiliyDetails },
      });
    }
  }, [items, returnEligibiliyDetails]);

  return (
    <>
      {/* Loader for select power */}
      {isLoading && <CommonLoader />}
      <h3 className="margin-l5" style={{ color: '#3C3C3C', fontFamily: 'Roboto' }}>
        <LinkProvider
          className="no-decoration back-cta inline-block cursor-pointer"
          to="/customer/account/"
        >
          <i aria-hidden="true" className="fa fa-angle-left fw700 fs18 margin-r15 pos-rel"></i>
          {EXCHANGE_RETURN}
        </LinkProvider>
      </h3>
      <div className="margin-t30 display-flex">
        <div className="bora-8" style={{ width: '70vw', marginRight: '5px' }}>
          {!returnIdItem && !isExchangeOnlyCase && (
            <SelectReason
              SecStep={SecStep}
              dataLocale={dataLocale}
              isExpandable={isExpandable}
              item={currentItem}
              reason={returnPrimaryReason}
              returnEligibiliyDetails={returnEligibiliyDetails}
              returnItemId={returnItemId}
              secondStep={secondStep}
              setIsExpandable={setIsExpandable}
            />
          )}
          {secondStep && !returnIdItem && !isExchangeOnlyCase && (
            <ReturnChooseMode
              isExpandable={isExpandable}
              setFifthStep={setFifthStep}
              setFinalStep={setFinalStep}
              setFourthStep={setFourthStep}
              setIsExpandable={setIsExpandable}
              setThirdStep={setThirdStep}
              showREtype={showREtype}
            />
          )}
          {thirdStep && (
            <ReturnTypeMethod
              exchangeNewFlow={exchangeNewFlow}
              isExchangeOnlyCase={isExchangeOnlyCase}
              isExpandable={isExpandable}
              item={currentItem}
              location={location}
              match={match}
              returnConfig={returnConfig}
              returnIdItem={returnIdItem}
              setFifthStep={setFifthStep}
              setFinalStep={setFinalStep}
              setFourthStep={setFourthStep}
              setIsExpandable={setIsExpandable}
            />
          )}
          {fourthStep && cartData && cartData.itemsCount > 0 && (
            <ShippingAddressExchange
              dataLocale={dataLocale}
              isExchangeOnlyCase={isExchangeOnlyCase}
              isExpandable={isExpandable}
              returnIdItem={returnIdItem}
              setFifthStep={setFifthStep}
              setFinalStep={setFinalStep}
              setIsExpandable={setIsExpandable}
            />
          )}
          {fifthStep && cartData?.items?.[0]?.powerRequired === 'POWER_REQUIRED' && (
            <AddPower
              cartData={cartData}
              currentItem={currentItem}
              dataLocale={dataLocale}
              hideLoader={hideLoader}
              isExchangeOnlyCase={isExchangeOnlyCase}
              isExpandable={isExpandable}
              method={method}
              open={open}
              orderData={
                orderDetails && orderDetails?.result?.orders && orderDetails?.result?.orders[0]
              }
              returnIdItem={returnIdItem}
              selectedPower={selectedPower}
              setFinalStep={setFinalStep}
              setIsExpandable={setIsExpandable}
              setMethod={setMethod}
              setMethodState={setMethodState}
              setOpen={setOpen}
              setSelectedPower={setSelectedPower}
              setShowFinalSubmitBtn={setShowFinalSubmitBtn}
              showLoader={showLoader}
            />
          )}
          {finalStep && finalStep.length > 0 && (
            <ConfirmationRequest
              dataLocale={dataLocale}
              finalStep={finalStep}
              history={history}
              returnItemId={returnItemId}
              returnOrderId={returnOrderId}
              showFinalSubmitBtn={showFinalSubmitBtn}
              userAddress={userAddress}
            />
          )}
        </div>
        <div
          className="bora-8 order-box"
          style={{
            width: '30vw',
            height: 'fit-content',
            marginLeft: '5px',
            marginTop: '10px',
            padding: '5px',
          }}
        >
          <ReturnProductCard
            item={currentReturnItem?.item}
            refundMethodRequest={refundMethodRequest}
            top="60%"
          />
        </div>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    exchangeFlowSet: state.myAccount.exchangeFlowSet,
    dataLocale: state.locale,
    orderDetails: state.order.orderDetails,
    userAddress: state.returnExchange.userAddress,
    breadcrumb: state.category.breadcrumb,
    cartData,
    returnConfig: state.myAccount.returnConfig,
    returnEligibiliyDetails: state.returnExchange.returnEligibiliyDetails,
    returnEligibiliyDetailsLoading: state.returnExchange.returnEligibiliyDetailsLoading,
    returnReasons: state.returnExchange.returnReasons,
    location: state.router.location,
    exchangeOrderId: state.returnExchange.exchangeOrderId,
    paymentMethods: state.checkout.paymentMethods,
    exchangeItemId: state.returnExchange.exchangeItemId,
    exchangeNewFlow: state.returnExchange.exchangeNewFlow,
    currentReturnItem: state.returnExchange.currentReturnItem,
    refundEstimateData: state.returnExchange.refundEstimateData,
    getRefundEstimate: state.returnExchange.getRefundEstimate,
    productData: state.product.productData,
    storeAddress: state.returnExchange.storeAddress,
    powerSubmitted: state.success.powerSubmitted,
    isLoading: state.returnExchange.isLoading,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    isExchangeFlowSet: data => dispatch(isExchangeFlowSet(data)),
    saveUserAddress: address => dispatch(saveUserAddress(address)),
    commonAction: bindActionCreators(commonAction, dispatch),
    getReturnReasons: classification => dispatch(getReturnReasons(classification)),
    setExchangeOrderAndItem: (orderId, itemId) =>
      dispatch(setExchangeOrderAndItem(orderId, itemId)),
    getOrder: data => dispatch(getOrder(data)),
    getOrderItemsReturnElgibilty: data => dispatch(getOrderItemsReturnElgibilty(data)),
    createReturn: (orderId, data) => dispatch(createReturn(orderId, data)),
    setCurrentReturnItem: data => dispatch(setCurrentReturnItem(data)),
    setNewExchangeFLow: flag => dispatch(setNewExchangeFLow(flag)),
    cancelReturnItem: (orderId, returnId) => dispatch(cancelReturnItem(orderId, returnId)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnReasonNew);
